import POVItem from '../POVItem/POVItem';

class POVBlock {
  constructor(contentfulNode) {
    this.id = contentfulNode?.id;
    this.title = contentfulNode?.pointOfViewTitle;
    this.label = contentfulNode?.pointOfViewLabel;
    this.image = {
      fluid: contentfulNode?.pointOfViewImage?.gatsbyImageData,
      title: contentfulNode?.pointOfViewImage?.title
    }
    this.video = contentfulNode?.pointOfViewVideo;
    this.videoLandscape = contentfulNode?.videoLandscape;
    this.bodyRichJSON = contentfulNode?.pointOfViewBody?.raw && contentfulNode.pointOfViewBody;
    // bodyString is to handle static content supplied through json files rather than contentful
    this.bodyString = contentfulNode?.pointOfViewBody?.subtitle ? contentfulNode.pointOfViewBody.subtitle : typeof contentfulNode?.pointOfViewBody === 'string' && contentfulNode.pointOfViewBody;
    this.items = contentfulNode?.pointOfViewItems ? contentfulNode?.pointOfViewItems.map(povItem => new POVItem(povItem)) : null;
    this.ctaText = contentfulNode?.ctaText;
    this.ctaUrl = contentfulNode?.ctaUrl;
    this.imageLeft = contentfulNode?.imageLeft;
    this.layout = contentfulNode?.layout;
    this.type = contentfulNode?.internal?.type;
  }
}

export default POVBlock;
